import { domainLabels } from './scenario-domains';

/**
 * Why a case-level run would refuse a case, as the eval page says it everywhere: the Calculate
 * gate, under the active case, and on the picker's tiles. "Case incomplete: missing DCA, Taxes ·
 * archived Expenses". It formats EvaluationCase::Readiness's missing and archived domains, which
 * the BE sends; it decides nothing itself. Null for a case with neither.
 *
 * @param {string[]} missing - Registry keys with no scenario.
 * @param {string[]} archived - Registry keys whose scenario is archived.
 * @return {string | null} The text, or null.
 */
export function caseIncompleteText(
  missing: readonly string[] = [],
  archived: readonly string[] = []
): string | null {
  const parts = [
    missing.length ? `missing ${domainLabels(missing)}` : null,
    archived.length ? `archived ${domainLabels(archived)}` : null,
  ].filter(Boolean);
  return parts.length ? `Case incomplete: ${parts.join(' · ')}` : null;
}
